import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7fd2360"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nonbid_success" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"model\" data-v-e7fd2360><div class=\"title\" data-v-e7fd2360>基本信息 <a href=\"/list\" data-v-e7fd2360>返回订单列表</a></div><div class=\"list\" data-v-e7fd2360><p data-v-e7fd2360>订单编号：ADF11233123SDFSDF</p><p data-v-e7fd2360>订单状态：已出函</p><p data-v-e7fd2360>支付状态：已支付</p><p data-v-e7fd2360>应付金额：10000元</p><p data-v-e7fd2360>实付金额：0元</p><p data-v-e7fd2360>联系人：张三</p><p data-v-e7fd2360>联系方式：18612345678</p><p data-v-e7fd2360>出函机构：深圳中联银融资担保有限公司</p></div></div><div class=\"model\" data-v-e7fd2360><div class=\"title\" data-v-e7fd2360>优惠券信息</div><div class=\"list\" data-v-e7fd2360><p data-v-e7fd2360>优惠编号：CCC11233123</p><p data-v-e7fd2360>优惠金额：100元</p></div></div><div class=\"model\" data-v-e7fd2360><div class=\"title\" data-v-e7fd2360>保函信息</div><div class=\"list\" data-v-e7fd2360><p data-v-e7fd2360>项目名称：深圳市福田区莲花中学篮球场翻修工程</p><p data-v-e7fd2360>产品种类：履约保函</p><p data-v-e7fd2360>受益人名称：深圳市福田区莲花中学</p><p data-v-e7fd2360>受益人税号：879789IUEIO896767869</p><p data-v-e7fd2360>被保证人名称：深圳蔓延科技有限公司</p><p data-v-e7fd2360>被保证人税号：879789IUEIO896767869</p><p data-v-e7fd2360>担保金额：100万元</p><p data-v-e7fd2360>担保期限：365天</p><p data-v-e7fd2360>截止日期：2023年12月30日</p></div></div>", 3)
const _hoisted_5 = { class: "model" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "出函进度", -1))
const _hoisted_7 = { class: "steps" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "make" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "a" }, "保函申请"),
  /*#__PURE__*/_createElementVNode("div", { class: "b" }, "保函申请提交成功"),
  /*#__PURE__*/_createElementVNode("div", { class: "t" }, "2022/11/16 10:15:11")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "make" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "a" }, "订单确认"),
  /*#__PURE__*/_createElementVNode("div", { class: "b" }, "保函订单已确认"),
  /*#__PURE__*/_createElementVNode("div", { class: "t" }, "2022/11/16 11:20:05")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "make" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "a" }, "风控审批"),
  /*#__PURE__*/_createElementVNode("div", { class: "b" }, "风控已审批"),
  /*#__PURE__*/_createElementVNode("div", { class: "t" }, "2022/11/17 13:21:25")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "make" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "a" }, "保费支付"),
  /*#__PURE__*/_createElementVNode("div", { class: "b" }, "已成功支付保费"),
  /*#__PURE__*/_createElementVNode("div", { class: "t" }, "2022/11/17 13:41:25")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "make" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "a" }, "签署协议"),
  /*#__PURE__*/_createElementVNode("div", { class: "b" }, "已完成协议签署"),
  /*#__PURE__*/_createElementVNode("div", { class: "t" }, "2022/11/17 15:23:25")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "make" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "a" }, "成功出函"),
  /*#__PURE__*/_createElementVNode("div", { class: "b" }, "系统成功出函"),
  /*#__PURE__*/_createElementVNode("div", { class: "t" }, "2022/11/17 15:25:25")
], -1))
const _hoisted_14 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_van_steps, {
          direction: "vertical",
          active: 5
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.downbh && _ctx.downbh(...args)), ["stop"]))
      }, "取消订单")
    ])
  ]))
}